import { render, staticRenderFns } from "./CollaboratorIcon.vue?vue&type=template&id=11b212a8&scoped=true&"
import script from "./CollaboratorIcon.vue?vue&type=script&lang=js&"
export * from "./CollaboratorIcon.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorIcon.vue?vue&type=style&index=0&id=11b212a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b212a8",
  null
  
)

export default component.exports